"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Bracket = _interopRequireDefault(require("./Bracket.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Bracket = function Bracket(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(_Bracket["default"], {
    className: "formula-bracket"
  }, value);
};
Bracket.propTypes = {
  value: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Bracket;